'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fp = require('lodash/fp');

var _recompose = require('recompose');

var _canvasUtil = require('./dnd/canvasUtil');

var _analytics = require('../analytics');

var omitProps = (0, _recompose.compose)(_recompose.mapProps, _fp.omit);

var shortcutElementHandlers = {
    handleDoubleClick: function handleDoubleClick(_ref) {
        var canvasNode = _ref.canvasNode,
            createShortcutCard = _ref.createShortcutCard,
            gridSize = _ref.gridSize,
            currentBoardId = _ref.currentBoardId,
            isEditable = _ref.isEditable;
        return function (event) {
            if (!canvasNode || !isEditable) return;

            var canvasPositionPx = {
                x: event.clientX,
                y: event.clientY - 1
            };

            var _getCanvasLocation = (0, _canvasUtil.getCanvasLocation)(canvasNode, canvasPositionPx, gridSize, currentBoardId),
                location = _getCanvasLocation.location;

            createShortcutCard({ location: location });

            (0, _analytics.analyticsEvent)('created-card-doubleclick');
        };
    }
};

var shortcutElementDecorator = (0, _recompose.compose)((0, _recompose.withState)('canvasNode', 'setShortcutHandlerCanvasNode', null), (0, _recompose.withHandlers)(shortcutElementHandlers), omitProps(['canvasNode']));

exports.default = shortcutElementDecorator;


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/canvasShortcutElementDecorator.js
// module id = 1688
// module chunks = 0